module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Sign-in-fabddfa9dc636645d3dbdf37c9fe9828.svg";